module.exports = __webpack_public_path__ + "img/start_black_panther.c6e25f0d.png";